module.exports = __webpack_public_path__ + "img/bx-1.ed7e9731.jpg";